function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.416,15.332C30.416,18.649 29.34,21.713 27.526,24.199L36.675,33.356C37.578,34.259 37.578,35.726 36.675,36.63C35.772,37.533 34.304,37.533 33.401,36.63L24.252,27.473C21.766,29.294 18.702,30.364 15.384,30.364C7.081,30.364 0.352,23.636 0.352,15.332C0.352,7.028 7.081,0.3 15.384,0.3C23.688,0.3 30.416,7.028 30.416,15.332ZM15.384,25.739C21.13,25.739 25.791,21.077 25.791,15.332C25.791,9.587 21.13,4.925 15.384,4.925C9.639,4.925 4.978,9.587 4.978,15.332C4.978,21.077 9.639,25.739 15.384,25.739Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.95519dac579ecbba5c38aaae71ca9ba2.svg";